import { z } from "zod";

/**
 * An empty string means "no email", so it's treated the same as omitting the
 * field instead of failing z.email(). Uses the rfc5322 pattern instead of the
 * default so accented local parts aren't rejected.
 */
export const PersonEmailSchema = z.preprocess(
  (val) => (typeof val === "string" && val.trim() === "" ? undefined : val),
  z.email({ pattern: z.regexes.rfc5322Email }).max(128).optional(),
);

/** No format or length check, so old bad emails already in the db don't blow up reads. */
export const PersonEmailReadSchema = z.preprocess(
  (val) => (typeof val === "string" && val.trim() === "" ? undefined : val),
  z.string().optional(),
);

export const PersonFactNodeContentSchema = z.object({
  nodeType: z.literal("person"),
  version: z.literal("1"),

  name: z.string().max(128),
  alias: z.string().max(128).optional(),

  contact: z
    .object({
      phoneNumber: z
        .string()
        .max(128)
        .optional()
        .describe("The phone number for this person, including country code"),
      email: PersonEmailReadSchema,
      website: z.string().optional(),
      linkedin: z.string().optional(),
      country: z.string().max(128).optional(),
      timezone: z
        .string()
        .max(128)
        .optional()
        .describe("The timezone for this person, e.g UTC+2"),
    })
    .optional(),
});

export const PersonWorksAtFactEdgeMetadataSchema = z.object({
  edgeType: z.literal("worksAt"),
  version: z.literal("1"),
  joinedAt: z
    .date()
    .optional()
    .describe("If available, the date this person joined the company"),
  role: z
    .string()
    .max(128)
    .optional()
    .describe("The person's role at the company"),
});

export const PersonKnowsFactEdgeMetadataSchema = z.object({
  edgeType: z.literal("knowsPerson"),
  version: z.literal("1"),
  relationship: z
    .string()
    .max(128)
    .optional()
    .describe("The type of relationship between two persons"),
});
